import * as $ from "jquery";
import { Grid } from 'ag-grid-community';
import { param } from "jquery";
import Handlebars from "Handlebars";

export default class PromotionsComponent {
    constructor() {
        this.componentSelector = "#report-promotions";
        this.modalTemplateSelector = "#promotion-modal-template";
        this.modalTemplate;
        this.grid = null;
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        instance.search(instance);

        const modalTemplate = $(this.modalTemplateSelector).html();
        if (modalTemplate !== undefined) {
            this.modalTemplate = Handlebars.compile(modalTemplate);
        }
    }

    search(instance) {
        axios({
            method: 'post',
            url: "/promotions/campaigns",
            data: {}
        }).then(function (response) {
            console.log(JSON.parse(response.data));
            instance.render(instance, JSON.parse(response.data));
        }).catch(function (response) {
        });
    }

    currencyFormatter(params) {
        return new Intl.NumberFormat('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(params.value);
    };

    buttonRenderer(params) {
        var button = document.createElement('button');
        button.innerHTML = 'Redigera';
        button.addEventListener('click', function () {
            params.context.loadModal(params.value, params.context);
        });
        return button;
    }

    loadModal(id, instance) {
        axios({
            method: 'post',
            url: "/promotion/promotionbyid",
            data: {id: id}
        }).then(function (response) {
            instance.showModal(JSON.parse(response.data), instance);
        }).catch(function (response) {
        });
    }

    showModal(data, instance) {
        $('#promotions-modal').html(instance.modalTemplate(data));

        setTimeout("$('#edit-modal').modal('show');", 10);
        
        console.log(data);
    }

    render(instance, data) {

        if (instance.grid == null) {
            instance.grid = {
                context: instance,
                columnDefs: [
                    {
                        headerName: 'Id', field: 'Id',
                        width: 100,
                    },
                    { headerName: 'Kampanj', field: 'CampaignId' },
                    {
                        headerName: 'Kampanjtyp', field: 'CampaignType',
                        width: 140,
                        type: 'centerAligned',
                    },
                    { headerName: 'Beskrivning', field: 'GeneralDescription' },
                    { headerName: 'Startdatum', field: 'StartDateFormatted' },
                    { headerName: 'Slutdatum', field: 'EndDateFormatted' },
                    { headerName: 'Rabattkod', field: 'PromotionCode' },
                    { headerName: 'Site', field: 'Tagging' },
                    {
                        headerName: "",
                        field: 'Id',
                        cellRenderer: instance.buttonRenderer,
                        width: 120,
                    }
                ],
                rowData: data,
                defaultColDef: { sortable: true, filter: true },
                domLayout: 'autoHeight',
            };

            var eGridDiv = document.querySelector('#report');
            new Grid(eGridDiv, instance.grid);
        }
        else {
            instance.grid.api.setRowData(data);
        }
    }
}